<template>
  <div class="customer-information">
    <b-row>
      <b-col>
        <!-- Customer Information Section (from Step 2) -->
        <div
          v-if="customerData"
          class="customer-info-section"
        >
          <b-row>
            <b-col cols="12">
              <b-form-group class="group-input">
                <div class="d-flex justify-content-between">
                  <label class="form-label">
                    {{
                      $t(
                        "stepGuideControl.stepVerifyInfo.formVerifyContract.labelCustomerType"
                      )
                    }}
                  </label>
                </div>
                <b-input-group class="input-group-merge">
                  <b-form-input
                    :value="displayCustomerType"
                    class="input-height"
                    disabled
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12">
              <b-form-group class="group-input">
                <div class="d-flex justify-content-between">
                  <label class="form-label">
                    Số hợp đồng
                  </label>
                </div>
                <b-input-group class="input-group-merge">
                  <b-form-input
                    :value="displayContractCode"
                    class="input-height"
                    disabled
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col
              :cols="12"
              :md="isIndividual ? 12 : 6"
              :class="isBusinessOrHousehold ? 'pr-md-0' : ''"
            >
              <b-form-group class="group-input">
                <div class="d-flex justify-content-between">
                  <label class="form-label">
                    {{
                      $t(
                        "stepGuideControl.stepVerifyInfo.formVerifyContract.labelCustomer"
                      )
                    }}
                  </label>
                </div>
                <b-input-group class="input-group-merge">
                  <b-form-input
                    :value="displayCustomerName"
                    class="input-height"
                    disabled
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col
              v-if="isBusinessOrHousehold"
              cols="12"
              md="6"
            >
              <b-form-group class="group-input">
                <div class="d-flex justify-content-between">
                  <label class="form-label">
                    {{
                      $t(
                        "stepGuideControl.stepVerifyInfo.formVerifyContract.labelTaxCode"
                      )
                    }}
                  </label>
                </div>
                <b-input-group class="input-group-merge">
                  <b-form-input
                    :value="displayTaxCode"
                    class="input-height"
                    disabled
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row v-if="isIndividual">
            <b-col
              cols="12"
              md="6"
              class="pr-md-0"
            >
              <b-form-group class="group-input">
                <div class="d-flex justify-content-between">
                  <label class="form-label">
                    {{
                      $t(
                        "stepGuideControl.stepVerifyInfo.formVerifyContract.labelDateOfBirth"
                      )
                    }}
                  </label>
                </div>
                <b-input-group class="input-group-merge">
                  <b-form-input
                    :value="displayDateOfBirth"
                    class="input-height"
                    disabled
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              md="6"
            >
              <b-form-group class="group-input">
                <div class="d-flex justify-content-between">
                  <label class="form-label">
                    {{
                      $t(
                        "stepGuideControl.stepVerifyInfo.formVerifyContract.labelGender"
                      )
                    }}
                  </label>
                </div>
                <b-input-group class="input-group-merge">
                  <b-form-input
                    :value="displayGender"
                    class="input-height"
                    disabled
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col
              cols="12"
              md="6"
              class="pr-md-0"
            >
              <b-form-group class="group-input">
                <div class="d-flex justify-content-between">
                  <label class="form-label">
                    {{
                      $t(
                        "stepGuideControl.stepVerifyInfo.formVerifyContract.labelIdType"
                      )
                    }}
                  </label>
                </div>
                <b-input-group class="input-group-merge">
                  <b-form-input
                    :value="displayIdType"
                    class="input-height"
                    disabled
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              md="6"
            >
              <b-form-group class="group-input">
                <div class="d-flex justify-content-between">
                  <label class="form-label">
                    {{
                      $t(
                        "stepGuideControl.stepVerifyInfo.formVerifyContract.labelIdNumber"
                      )
                    }}
                  </label>
                </div>
                <b-input-group class="input-group-merge">
                  <b-form-input
                    :value="displayIdNumber"
                    class="input-height"
                    disabled
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col
              cols="12"
              md="6"
              class="pr-md-0"
            >
              <b-form-group class="group-input">
                <div class="d-flex justify-content-between">
                  <label class="form-label">
                    {{
                      $t(
                        "stepGuideControl.stepVerifyInfo.formVerifyContract.labelIssueDate"
                      )
                    }}
                  </label>
                </div>
                <b-input-group class="input-group-merge">
                  <b-form-input
                    :value="displayIssueDate"
                    class="input-height"
                    disabled
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              md="6"
            >
              <b-form-group class="group-input">
                <div class="d-flex justify-content-between">
                  <label class="form-label">
                    {{
                      $t(
                        "stepGuideControl.stepVerifyInfo.formVerifyContract.labelIssuePlace"
                      )
                    }}
                  </label>
                </div>
                <b-input-group class="input-group-merge">
                  <b-form-input
                    :value="displayIssuePlace"
                    class="input-height"
                    disabled
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
        </div>

        <!-- Representative Information Section (from Step 2) -->
        <div
          v-if="isBusinessOrHousehold"
          class="representative-info-section"
        >
          <h5 class="section-title">
            {{
              $t(
                "stepGuideControl.stepVerifyInfo.formVerifyContract.titleRepresentativeInfo"
              )
            }}
          </h5>
          <b-row>
            <b-col
              cols="12"
              md="6"
              class="pr-md-0"
            >
              <b-form-group class="group-input">
                <div class="d-flex justify-content-between">
                  <label class="form-label">
                    {{
                      $t(
                        "stepGuideControl.stepVerifyInfo.formVerifyContract.labelRepresentative"
                      )
                    }}
                  </label>
                </div>
                <b-input-group class="input-group-merge">
                  <b-form-input
                    :value="displayRepresentativeName"
                    class="input-height"
                    disabled
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              md="6"
            >
              <b-form-group class="group-input">
                <div class="d-flex justify-content-between">
                  <label class="form-label">
                    {{
                      $t(
                        "stepGuideControl.stepVerifyInfo.formVerifyContract.labelPosition"
                      )
                    }}
                  </label>
                </div>
                <b-input-group class="input-group-merge">
                  <b-form-input
                    :value="displayRepresentativePosition"
                    class="input-height"
                    disabled
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
        </div>

        <!-- Contact Information Section (from Step 3) -->
        <div
          v-if="customerData"
          class="contact-info-section"
        >
          <h5 class="section-title">
            {{
              $t(
                "stepGuideControl.stepVerifyInfo.formVerifyContract.titleContactInfo"
              )
            }}
          </h5>

          <b-row class="administrative-row">
            <b-col
              cols="12"
              md="6"
              class="pr-md-0"
            >
              <b-form-group class="group-input">
                <div class="d-flex justify-content-between">
                  <label class="form-label">
                    {{
                      $t(
                        "stepGuideControl.stepVerifyInfo.formVerifyContract.labelProvince"
                      )
                    }}
                  </label>
                </div>
                <b-input-group class="input-group-merge">
                  <b-form-input
                    :value="displayProvince"
                    class="input-height"
                    disabled
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              md="6"
            >
              <b-form-group class="group-input">
                <div class="d-flex justify-content-between">
                  <label class="form-label">
                    {{
                      $t(
                        "stepGuideControl.stepVerifyInfo.formVerifyContract.labelWard"
                      )
                    }}
                  </label>
                </div>
                <b-input-group class="input-group-merge">
                  <b-form-input
                    :value="displayWard"
                    class="input-height"
                    disabled
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12">
              <b-form-group class="group-input">
                <div class="d-flex justify-content-between">
                  <label class="form-label">
                    {{
                      $t(
                        "stepGuideControl.stepVerifyInfo.formVerifyContract.labelAddress"
                      )
                    }}
                  </label>
                </div>
                <b-input-group class="input-group-merge">
                  <b-form-input
                    :value="displayAddress"
                    class="input-height"
                    disabled
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col
              cols="12"
              md="6"
              class="pr-md-0"
            >
              <b-form-group class="group-input">
                <div class="d-flex justify-content-between">
                  <label class="form-label">
                    {{
                      $t(
                        "stepGuideControl.stepVerifyInfo.formVerifyContract.labelContactEmail"
                      )
                    }}
                  </label>
                </div>
                <b-input-group class="input-group-merge">
                  <b-form-input
                    :value="displayContactEmail"
                    class="input-height"
                    type="email"
                    disabled
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              md="6"
            >
              <b-form-group class="group-input">
                <div class="d-flex justify-content-between">
                  <label class="form-label">
                    {{
                      $t(
                        "stepGuideControl.stepVerifyInfo.formVerifyContract.labelFax"
                      )
                    }}
                  </label>
                </div>
                <b-input-group class="input-group-merge">
                  <b-form-input
                    :value="displayFax"
                    class="input-height"
                    disabled
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>

          <b-form-group class="group-input">
            <phone-input
              :phone-data="phoneData"
              disabled
            />
          </b-form-group>
        </div>
        <div
          v-else
          class="no-data-message"
        >
          <p>{{ $t('common.textNoDataAvailable') || 'Chưa có thông tin khách hàng' }}</p>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormInput,
  BFormGroup,
  BInputGroup,
} from 'bootstrap-vue'
import PhoneInput from '@/views/auth/PhoneInput.vue'
import { CUSTOMER_TYPE } from '@/constants/customerType'
import { createNamespacedHelpers } from 'vuex'

const { mapGetters } = createNamespacedHelpers('auth')

export default {
  name: 'CustomerInformation',

  components: {
    BRow,
    BCol,
    BFormInput,
    BFormGroup,
    BInputGroup,
    PhoneInput,
  },

  props: {
    contractData: {
      type: Object,
      default: null,
    },
    options: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapGetters(['user']),

    customerData() {
      return this.contractData
    },

    displayContractCode() {
      return this.user?.data?.vContract?.contractCode || ''
    },

    isIndividual() {
      if (!this.customerData || !this.customerData.identityInfo) return false
      const { customerType } = this.customerData.identityInfo
      return customerType && String(customerType) === CUSTOMER_TYPE.INDIVIDUAL
    },

    isBusiness() {
      if (!this.customerData || !this.customerData.identityInfo) return false
      const { customerType } = this.customerData.identityInfo
      return customerType && String(customerType) === CUSTOMER_TYPE.BUSINESS
    },

    isHousehold() {
      if (!this.customerData || !this.customerData.identityInfo) return false
      const { customerType } = this.customerData.identityInfo
      return customerType && String(customerType) === CUSTOMER_TYPE.HOUSEHOLD
    },

    isBusinessOrHousehold() {
      return this.isBusiness || this.isHousehold
    },

    displayCustomerType() {
      if (!this.customerData || !this.customerData.identityInfo || !this.customerData.identityInfo.customerType) return ''
      const customerTypeValue = String(this.customerData.identityInfo.customerType)
      const option = this.options.customerType.find(opt => opt.value === customerTypeValue)
      return option ? option.label : ''
    },

    displayIdType() {
      if (!this.customerData || !this.customerData.identityInfo || !this.customerData.identityInfo.documentType) return ''
      const documentTypeValue = String(this.customerData.identityInfo.documentType)
      const option = this.options.idType.find(opt => opt.value === documentTypeValue)
      return option ? option.label : ''
    },

    displayDateOfBirth() {
      if (!this.customerData || !this.customerData.birth) return ''
      return this.formatDateToDDMMYYYY(this.customerData.birth)
    },

    displayGender() {
      if (!this.customerData || !this.customerData.sex) return ''
      const option = this.options.gender.find(opt => opt.value === this.customerData.sex)
      return option ? option.text : ''
    },

    displayIssueDate() {
      if (!this.customerData || !this.customerData.identityInfo || !this.customerData.identityInfo.documentIssuedDate) return ''
      return this.formatDateToDDMMYYYY(this.customerData.identityInfo.documentIssuedDate)
    },

    displayIssuePlace() {
      if (!this.customerData || !this.customerData.identityInfo || !this.customerData.identityInfo.documentIssuedPlace) return ''
      return this.customerData.identityInfo.documentIssuedPlace
    },

    displayCustomerName() {
      return (this.customerData && this.customerData.cusName) || ''
    },

    displayIdNumber() {
      if (!this.customerData || !this.customerData.identityInfo || !this.customerData.identityInfo.documentNumber) return ''
      return this.customerData.identityInfo.documentNumber
    },

    displayTaxCode() {
      if (!this.customerData || !this.customerData.identityInfo || !this.customerData.identityInfo.taxCode) return ''
      return this.customerData.identityInfo.taxCode
    },

    displayRepresentativeName() {
      return (this.customerData && this.customerData.represent && this.customerData.represent.fullName) || ''
    },

    displayRepresentativePosition() {
      return (this.customerData && this.customerData.represent && this.customerData.represent.position) || ''
    },

    displayAddress() {
      return (this.customerData && this.customerData.contactInfo && this.customerData.contactInfo.address) || ''
    },

    displayContactEmail() {
      return (this.customerData && this.customerData.contactInfo && this.customerData.contactInfo.email) || ''
    },

    displayFax() {
      return (this.customerData && this.customerData.contactInfo && this.customerData.contactInfo.fax) || ''
    },

    displayProvince() {
      if (!this.customerData || !this.customerData.contactInfo) return ''
      const province = this.customerData.contactInfo.city || this.customerData.contactInfo.province
      if (!province) return ''

      // If province is a string, return it
      if (typeof province === 'string') return province

      // If province has name/fullName, return it
      if (province.name || province.fullName) {
        return province.name || province.fullName
      }

      // If province has code, find in options
      if (province.code && this.options.province && this.options.province.length > 0) {
        const provinceOption = this.options.province.find(opt => opt.value === province.code || opt.code === province.code)
        if (provinceOption) {
          return provinceOption.label || provinceOption.name || provinceOption.fullName || ''
        }
      }

      return ''
    },

    displayWard() {
      const { contactInfo } = this.customerData || {}
      if (!contactInfo || !contactInfo.ward) return ''
      const { ward } = contactInfo

      // If ward is a string, return it
      if (typeof ward === 'string') return ward

      // If ward has name/fullName, return it
      if (ward.name || ward.fullName) {
        return ward.name || ward.fullName
      }

      // If ward has code, find in options
      if (ward.code && this.options.ward && this.options.ward.length > 0) {
        const wardOption = this.options.ward.find(opt => opt.value === ward.code || opt.code === ward.code)
        if (wardOption) {
          return wardOption.label || wardOption.name || wardOption.fullName || ''
        }
      }

      return ''
    },

    phoneData() {
      if (!this.customerData || !this.customerData.contactInfo) {
        return {
          countryAbbr: '',
          countryCode: '',
          phone: '',
          isValid: true,
          isRequired: false,
        }
      }
      const phoneLocale = this.customerData.contactInfo.phoneLocale || this.customerData.contactInfo.phone
      if (!phoneLocale) {
        return {
          countryAbbr: '',
          countryCode: '',
          phone: '',
          isValid: true,
          isRequired: false,
        }
      }

      const parts = phoneLocale.split('|')
      if (parts.length === 3) {
        return {
          countryAbbr: (parts[0] || 'vn').toLowerCase(),
          countryCode: parts[1] ? parts[1].replace(/^\+/, '') : '',
          phone: parts[2] || '',
          isValid: true,
          isRequired: false,
        }
      }

      return {
        countryAbbr: '',
        countryCode: '',
        phone: phoneLocale,
        isValid: true,
        isRequired: false,
      }
    },
  },

  methods: {
    formatDateToDDMMYYYY(dateString) {
      if (!dateString) return ''
      // Convert from YYYY-MM-DD to d/m/Y
      const parts = dateString.split('-')
      if (parts.length === 3) {
        const year = parts[0]
        const month = parts[1]
        const day = parts[2]
        return `${day}/${month}/${year}`
      }
      return dateString
    },
  },
}
</script>

<style lang="scss" scoped>
.input-height {
  height: 48px;
}

.customer-info-section,
.representative-info-section,
.contact-info-section {
  margin-bottom: 32px;

  .section-title {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 24px;
    color: #16213e;
  }
}

.group-input {
  margin-bottom: 32px;
}

.form-label {
  margin-bottom: 8px;
  font-weight: 500;
  color: #16213e;
}

.input-group-merge {
  .form-control:disabled {
    background-color: #efefef;
    color: #16213e;
    cursor: not-allowed;
  }
}

.no-data-message {
  text-align: center;
  padding: 40px 20px;
  color: #16213EB2;
  font-size: 14px;
}
</style>
